/** @format */

import Config from "config";
import { LoginType, Size } from "interfaces";
import { useMemo, useState } from "react";
import { EmailCard } from "./emailcard";
import { MetaMaskWallet } from "./metamask";
import { SocialCard } from "./socialcard";
import { TerraStationWallet } from "./terrastation";
import { KeplrWallet } from "./keplr";

const AdaptibleExtension = ({
  authInfos,
  loginType,
  size,
}: {
  authInfos: any;
  loginType: LoginType;
  size: Size;
}) => {
  switch (loginType) {
    case LoginType.BSC:
      return (
        <MetaMaskWallet
          key={`bsc-chain-${size}`}
          size={size}
          data={authInfos[loginType]}
          type={loginType}
        />
      );
    case LoginType.Terra:
      return <></>;
      return (
        <TerraStationWallet
          key={`terra-chain-${size}`}
          size={size}
          data={authInfos[loginType]}
        />
      );
    case LoginType.Avalanche:
      return (
        <MetaMaskWallet
          key={`avalanche-chain-${size}`}
          size={size}
          data={authInfos[loginType]}
          type={loginType}
        />
      );
    // case LoginType.Okex:
    //     return <MetaMaskWallet key={`okex-chain-${size}`} size={size} data={authInfos[loginType]} type={loginType} />
    case LoginType.Aura:
      return (
        <KeplrWallet
          key={`aura-chain-${size}`}
          size={size}
          data={authInfos[loginType]}
          type={loginType}
        />
      );
    case LoginType.Google:
      if (Config.MainnetUnsupportedChain.includes(LoginType.Google)) {
        return <></>;
      }
      return (
        <SocialCard
          key={`google-card-${size}`}
          size={size}
          data={authInfos[loginType]}
          type={loginType}
        />
      );
    case LoginType.Facebook:
      if (Config.MainnetUnsupportedChain.includes(LoginType.Facebook)) {
        return <></>;
      }
      return (
        <SocialCard
          key={`facebook-card-${size}`}
          size={size}
          data={authInfos[loginType]}
          type={loginType}
        />
      );
    case LoginType.Apple:
      return (
        <SocialCard
          key={`apple-card-${size}`}
          size={size}
          data={authInfos[loginType]}
          type={loginType}
        />
      );
    case LoginType.Email:
      return (
        <EmailCard
          key={`email-card-${size}`}
          size={size}
          data={authInfos[loginType]}
          type={loginType}
        />
      );
    default:
      return <></>;
  }
};

export const ExtensionLinkComponent = ({
  authInfos,
  size,
}: {
  authInfos: any;
  size: Size;
}) => {
  const [component, setComponent] = useState(<></>);

  useMemo(() => {
    setComponent(
      <>
        {Object.keys(authInfos)
          ?.sort((a, b) => {
            if (
              !Config.AntiWalletAuth.includes(Number(a)) &&
              Config.AntiWalletAuth.includes(Number(b))
            ) {
              return -1;
            }
            return 1;
          })
          .map((loginType, index) => (
            <AdaptibleExtension
              key={`adaptible-${index}`}
              authInfos={authInfos}
              loginType={Number(loginType)}
              size={size}
            />
          ))}
      </>
    );
  }, [authInfos, size]);

  return <>{component}</>;
};
